import React from 'react';
import { Link } from 'gatsby';
import * as styles from './blog-categories.module.scss';
import { ICategoriesData, ICategoryData } from '../../vitl-services/interfaces/blog';

interface IProps {
  slug: string;
  categoriesData: ICategoriesData;
}

const BlogCategories: React.FC<IProps> = ({ slug, categoriesData }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.filterLabels} data-testid="category-navbar">
          <Link to={'/'} data-testid="root-nav">
            <button
              className={slug === '' ? styles.buttonActive : styles.button}
            >
              All articles
            </button>
          </Link>
          {categoriesData?.map((category: ICategoryData) => (
            <Link
              to={`/${category.slug}`}
              key={category.id}
              data-testid={category.slug}
            >
              <button
                className={
                  category.slug === slug ? styles.buttonActive : styles.button
                }
              >
                {category.name}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogCategories;
